document.addEventListener('DOMContentLoaded', () => {
  const fadeElements = document.querySelectorAll('.about-fade-up');
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target); // Only animate once
      }
    });
  }, {
    root: null,
    rootMargin: '0px',
    threshold: 0.15
  });

  fadeElements.forEach(el => observer.observe(el));
});
